var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33331 10.8332C8.69119 11.3117 9.14778 11.7075 9.6721 11.994C10.1964 12.2805 10.7762 12.4508 11.3722 12.4935C11.9681 12.5362 12.5663 12.4502 13.1261 12.2414C13.6859 12.0326 14.1942 11.7058 14.6166 11.2832L17.1166 8.78322C17.8756 7.99738 18.2956 6.94487 18.2861 5.85238C18.2766 4.7599 17.8384 3.71485 17.0659 2.94231C16.2934 2.16978 15.2483 1.73157 14.1558 1.72208C13.0633 1.71259 12.0108 2.13256 11.225 2.89156L9.79165 4.31656",
    stroke: "current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 9.16677C11.3088 8.68833 10.8522 8.29245 10.3279 8.00599C9.80353 7.71953 9.22373 7.54918 8.62777 7.50649C8.03182 7.46381 7.43366 7.5498 6.87386 7.75862C6.31406 7.96744 5.80572 8.29421 5.38332 8.71677L2.88332 11.2168C2.12432 12.0026 1.70435 13.0551 1.71384 14.1476C1.72334 15.2401 2.16154 16.2851 2.93407 17.0577C3.70661 17.8302 4.75166 18.2684 5.84415 18.2779C6.93663 18.2874 7.98914 17.8674 8.77498 17.1084L10.2 15.6834",
    stroke: "current",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.380a2f7113e261b8f909819537830d3b.svg";
export { ForwardRef as ReactComponent };